export const usersPages = {
  list: () => import('./pages/UsersPage'),
};
